export default "__VITE_PUBLIC_ASSET__18b62739__"